<div class="tabs-container">
  <div class="p-segment" [class.p-scrollable]="scrollable">
    <button *ngFor="let tab of tabs" 
            class="p-segment-button" 
            [class.segment-button-checked]="selectedTab === tab.value"
            (click)="onTabChanged(tab.value)">
      
      <div class="tab-content-wrapper" [ngClass]="'mode-' + displayMode">
        <app-icon *ngIf="tab.icon && (displayMode === 'showIcon' || displayMode === 'onlyIcon')" 
                  [iconName]="tab.icon" 
                  class="tab-icon">
        </app-icon>
        
        <span class="p-segment-label" *ngIf="displayMode === 'onlyText' || displayMode === 'showIcon'">
          {{ tab.label }}
        </span>
      </div>

    </button>
  </div>
</div>